<ng-container *transloco="let t">
  <div class="d-flex justify-content-between align-items-center p-4 title-border">
    <h3 class="text-uppercase fst-normal">{{title}}</h3>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="p-4">
    <div>
      <h3 class="text-uppercase fst-normal">{{t("race.details.about")}}</h3>
      <p>
        <app-language-output [hrLabel]="race?.shortDescription" [srLabel]="race?.shortDescriptionSr"
                             [bsLabel]="race?.shortDescriptionBs" [enLabel]="race?.shortDescriptionEng"
                             [itLabel]="race?.shortDescriptionIta" [siLabel]="race?.shortDescriptionSlo"
                             [defaultLanguage]="eventItem?.defaultLanguage" [showAsInnerHtml]="true"
                             [defaultLabel]="t('race.details.empty')" [languages]="languages"/>
      </p>
      <div class="race-details pt-3 mb-2 mb-md-3">
        <div class="race-details__item">
          <div>
            <p class="fw-medium">{{t("event.item.start.date")}}</p>
            <p> {{
                race
                  ? (race.raceStart | localizedDate:'shortDate')
                  : '-'
              }} </p>
          </div>
        </div>
        <div class="race-details__item">
          <div>
            <p class="fw-medium"> {{t("event.item.start.time")}}</p>
            <p> {{
                race
                  ? (race.raceStart | localizedDate:'shortTime')
                  : '-'
              }} </p>
          </div>
        </div>
        <div class="race-details__item">
          <div>
            <p class="fw-medium"> {{t("event.item.time.limit")}}</p>
            <p>{{race?.raceStart|timeLimit:race?.raceEnd}} </p>
          </div>
        </div>
        <ng-container *ngIf="!isXxlScreen">
          <ng-container
            *ngTemplateOutlet="raceLocationTemplate; context: { title: t('race.details.start.location'), location: startWaypoint }"></ng-container>
          <ng-container
            *ngTemplateOutlet="raceLocationTemplate; context: { title: t('race.details.end.location'), location: finishWaypoint }"></ng-container>
        </ng-container>
      </div>
      <ng-container *ngIf="isXxlScreen">
        <div class="race-details pt-3">
          <ng-container
            *ngTemplateOutlet="raceLocationTemplate; context: { title: t('race.details.start.location'), location: startWaypoint }"></ng-container>
          <ng-container
            *ngTemplateOutlet="raceLocationTemplate; context: { title: t('race.details.end.location'), location: finishWaypoint }"></ng-container>
        </div>
      </ng-container>
    </div>

    @if (race?.raceScoring?.scoringDefinition) {
      <div class="pt-4">
        <h3 class="text-uppercase fst-normal">{{t("race.details.racing.points")}}</h3>
        <div class="row">
          <div class="col-12">
            @if (race!.raceScoring!.scoringFor === ScoringForType.ITRA) {
              <app-horizontal-box-list>
                <app-horizontal-box-list-item>
                      <span class="title-content fw-semibold">
                      {{t("race.details.itraPoints")}}
                      </span>
                  <span class="content">{{race?.raceScoring?.itraPoints ?? "-"}}</span>
                </app-horizontal-box-list-item>
                <app-horizontal-box-list-item>
                      <span class="title-content fw-semibold">
                         {{t("race.details.mountainLevel")}}
                        </span>
                  <span class="content">{{race?.raceScoring?.mountainLevel ?? "-"}}</span>
                </app-horizontal-box-list-item>
                <app-horizontal-box-list-item>
                <span class="title-content fw-semibold">
                        {{t("race.details.utmbQualifier")}}
                 </span>
                  <span class="content">{{race?.raceScoring?.utmbQualifier ?? "-"}}</span>
                </app-horizontal-box-list-item>
                <app-horizontal-box-list-item>
          <span class="title-content fw-semibold">
              {{t("race.details.finisherLevel")}}
                    </span>
                  <span class="content">{{race?.raceScoring?.finisherLevel ?? "-"}}</span>
                </app-horizontal-box-list-item>
              </app-horizontal-box-list>
            } @else if (race?.raceScoring?.scoringFor === ScoringForType.CONFIGURE
            && race?.raceScoring?.nameOne && race?.raceScoring?.valueOne) {
              <app-horizontal-box-list>
                <app-horizontal-box-list-item>
          <span class="title-content fw-semibold">
              {{race!.raceScoring!.nameOne}}
                    </span>
                  <span class="content">{{race!.raceScoring!.valueOne}}</span>
                </app-horizontal-box-list-item>
              </app-horizontal-box-list>
            }
          </div>
        </div>
      </div>
    }

    <div class="details-wrapper mt-4 px-3 py-4">
      <div class="details-wrapper__item">
        <img src="assets/img/svg/distance.svg" [alt]="t('app.map.elevation.graph.distance.m')"/>
        <div>
          <p>
            {{t("app.map.elevation.graph.distance.m")}} </p>
          <p>
            {{race?.length | raceLengthFormat:translocoService.getActiveLang():"km"}} </p>
        </div>
      </div>
      <div class="details-wrapper__item">
        <img src="assets/img/svg/elevation_1.svg" [alt]="t('app.map.elevation.graph.elevation')"/>
        <div>
          <p>
            {{t("app.map.elevation.graph.elevation")}} </p>
          <p>
            {{race | raceAscentDescentFormat}} </p>
        </div>
      </div>
      <div class="details-wrapper__item">
        <img src="assets/img/svg/control-points.svg" [alt]="t('race.details.controlPoints')"/>
        <div>
          <p>
            {{t("race.details.controlPoints")}} </p>
          <p>
            {{race?.waypoints?.length ?? "-"}}
          </p>
        </div>
      </div>
      <div class="details-wrapper__item">
        <img src="assets/img/svg/feed-zones.svg" [alt]="t('race.details.feedZones')"/>
        <div>
          <p>
            {{t("race.details.feedZones")}} </p>
          <p>
            {{race?.refreshmentCheckpointAmount ?? "-"}} </p>
        </div>
      </div>
      <div class="details-wrapper__item">
        <img src="assets/img/svg/highest-alt.svg" [alt]="t('race.details.max.altitude.short')"/>
        <div>
          <p>
            {{t("race.details.max.altitude.short")}} </p>
          <p>
            {{race?.maxAltitude ? race?.maxAltitude + "m" : "-"}} </p>
        </div>
      </div>
      <div class="details-wrapper__item">
        <img src="assets/img/svg/lowest-alt.svg" [alt]="t('race.details.min.altitude.short')"/>
        <div>
          <p>
            {{t("race.details.min.altitude.short")}} </p>
          <p>
            {{race?.minAltitude ? race?.minAltitude + "m" : "-"}} </p>
        </div>
      </div>
      <div class="details-wrapper__item">
        <img src="assets/img/svg/max-participants.svg" [alt]="t('race.details.max.participants')"/>
        <div>
          <p>
            {{t("race.details.max.participants")}} </p>
          <p>
            {{race?.maxParticipants ?? "-"}} </p>
        </div>
      </div>
      <div class="details-wrapper__item">
        <img src="assets/img/svg/registered-participants.svg" [alt]="t('race.details.reg.participants')"/>
        <div>
          <p>
            {{t("race.details.reg.participants")}} </p>
          <p>
            {{race?.competitorCount?.total ?? "-"}} </p>
        </div>
      </div>
    </div>

    @if (raceCommercialItems && raceCommercialItems.length > 0) {
      <div class="pt-4">
        <h3 class="text-uppercase fst-normal pb-2">{{t("race.details.pricing")}}</h3>
        <div class="row">
          @for (item of raceCommercialItems;track item) {
            <app-race-pricing-table [raceCommercialItem]="item" [event]="eventItem" [race]="race" [currencyLabel]="currencyLabel"
                                    [languages]="languages"></app-race-pricing-table>
          }
        </div>
      </div>
    }
    <div class="d-flex justify-content-end pt-4">
      <app-button-alt [text]="t('app.common.close')" [borderColor]="'var(--teal-500)'"
                      [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="onClose()"
                      [buttonColor]="'transparent'"></app-button-alt>
    </div>
  </div>
</ng-container>

<ng-template #raceLocationTemplate let-title="title" let-location="location">
  <div class="race-details__item">
    <div class="race-details__content">
      <p class="fw-medium">{{title}}</p>
      <p>{{location | waypointLocation:countries}}</p>
    </div>
  </div>
</ng-template>
